import {Image} from 'react-native';

const FastImage = Image;
FastImage.resizeMode = {
  contain: 'contain',
  cover: 'cover',
};
export const preload = () => {};
export default FastImage;
